import { render } from "./EditVotersGroup.vue?vue&type=template&id=4b024c6a&scoped=true"
import script from "./EditVotersGroup.vue?vue&type=script&lang=js"
export * from "./EditVotersGroup.vue?vue&type=script&lang=js"

import "./EditVotersGroup.vue?vue&type=style&index=0&id=4b024c6a&scoped=true&lang=css"

import exportComponent from "C:\\All Projects\\Digital Sinage Main\\Digital Sinage Admin\\media-device-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b024c6a"]])

export default __exports__